'use strict';

import _ from 'lodash';

module.exports = {
	type: 'RegexMatchVerifierContrib',

	regex: {},

	verify_regex: function(value) {
		if (!_.isString(value)) {
			return false;
		}

		var output = true;

		_.each(this.regex, (pattern, key) => {
			const match = value.match(pattern);

			if (match && match[0] === value) {
				return;
			}

			output = this.lang[key];

			return false;
		});

		return output;
	}
};
